import { render, staticRenderFns } from "./MiniWizardStickyBacker.vue?vue&type=template&id=53027b1b"
import script from "./MiniWizardStickyBacker.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickyBacker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports